// extracted by mini-css-extract-plugin
export default {"root":"SfBVw","item":"_9GT19","pictogrammers":"J9ci+","button":"NJile","subheading":"_04DCV"};